import { useAuth } from 'react-oidc-context';
import { NavLink } from 'react-router-dom';
import { roleLabel } from '../lib/roles';
import { getRuntimeConfig } from '../runtimeConfig';
import { useSession } from '../state/SessionContext';
import { photoSrc } from '../utils/photo';
import { Avatar } from './Avatar';

export function SidebarBrand() {
  return (
    <div className="sidebar-brand">
      <div className="sidebar-logo">U</div>
      <div>
        <div className="sidebar-title">UDB Console</div>
        <div className="sidebar-subtitle">Unified User Database</div>
      </div>
    </div>
  );
}

export function ProfileNavItem() {
  return (
    <NavLink
      to="/profile"
      className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <rect x="1.8" y="3" width="12.4" height="10" rx="1.6" stroke="currentColor" strokeWidth="1.4" />
        <circle cx="5.8" cy="7.1" r="1.4" stroke="currentColor" strokeWidth="1.2" />
        <path
          d="M3.8 10.7c.4-1 1.1-1.5 2-1.5s1.6.5 2 1.5"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M9.6 6.6h2.6M9.6 9.2h2.6"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
      </svg>
      <span className="nav-label">My profile</span>
    </NavLink>
  );
}

export function SidebarUser() {
  const auth = useAuth();
  const { me } = useSession();
  const name = me.name || me.username;

  return (
    <div className="sidebar-user">
      <NavLink
        to="/profile"
        title="My profile"
        className={({ isActive }) => `sidebar-user-link${isActive ? ' active' : ''}`}
      >
        <Avatar
          size="sm"
          name={name}
          photoSrc={photoSrc(getRuntimeConfig().apiUrl, me.id, me.photoVersion)}
        />
        <div className="sidebar-user-meta">
          <div className="sidebar-user-name">{name}</div>
          <div className="sidebar-user-role">{roleLabel(me.clientRole)}</div>
        </div>
      </NavLink>
      <button
        className="sidebar-signout"
        title="Sign out"
        aria-label="Sign out"
        onClick={() => void auth.signoutRedirect()}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M6.2 2.8H3.8a1 1 0 0 0-1 1v8.4a1 1 0 0 0 1 1h2.4"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
          <path
            d="M10.4 5.2L13.2 8l-2.8 2.8M13 8H6.6"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
}
